import { createImmutableObjectClass } from 'immutable-less';
export default class FetchedObjectPropertyField extends createImmutableObjectClass({
  propertyToken: null,
  valueType: 'FETCHED_OBJECT_PROPERTY'
}) {
  getIsValueEmpty() {
    return !this.propertyToken;
  }
  /**
   * @deprecated Prefer dot notation: .propertyToken
   */
  getPropertyToken() {
    return this.propertyToken;
  }
  /**
   * @deprecated Prefer dot notation: .valueType
   */
  getType() {
    return this.valueType;
  }
  getValue() {
    return this.propertyToken;
  }
  /**
   * @deprecated Prefer dot notation: .valueType
   */
  getValueType() {
    return this.valueType;
  }
}